import React from "react";
import styles from "./AgreementCheckBox.module.scss";

type Props = {
  children: React.ReactNode;
  value: boolean;
  handler: () => void;
};

const AgreementCheckBox: React.FC<Props> = ({ children, value, handler }) => {
  return (
    <div className={styles["agreement-wrapper"]}>
      <div className={styles["agreement"]}>
        <input
          type="checkbox"
          id="agreement"
          name="agreement"
          onChange={handler}
          checked={value}
        />
        <label htmlFor="agreement">{children}</label>
      </div>
    </div>
  );
};

export default AgreementCheckBox;
